import { SceneActionListItemDTO } from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'SceneActionGeneral',
  props: {
    actionToAdd: {
      type: Object as PropType<SceneActionListItemDTO>,
    },
    confirmDisabled: {
      required: false,
      type: Boolean,
    },
  },
  watch: {
    isConfirmEnabled: { 
      immediate:true,
      handler: function () {
        this.emitDisabled();
      }
    },
  },
  emits: ['confirm-disabled'],
})
export default class SceneActionGeneral extends Vue {
  actionToAdd!: SceneActionListItemDTO;
  confirmDisabled!: boolean;

  emitDisabled() {
    //computed property in child classes
    this.$emit('confirm-disabled', !(this as any).isConfirmEnabled);
  }
}
